/**
 *
 * Asynchronously loads the component for Admin Page
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
